import { render, staticRenderFns } from "./BrandCategory.vue?vue&type=template&id=0c215cda"
import script from "./BrandCategory.vue?vue&type=script&lang=js"
export * from "./BrandCategory.vue?vue&type=script&lang=js"
import style0 from "./BrandCategory.vue?vue&type=style&index=0&id=0c215cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports